import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Card, CardBlock, Row, Col } from 'reactstrap';
import { Table, Modal } from 'antd';
import Pagination from 'rc-pagination';
import Select from 'react-select';
import { SERVER_URL } from './../../../../config/host';
import * as actionScore from './../../../../actions/score';
import * as actionUser from './../../../../actions/user';

@connect(
  state => ({
    scoreState: state.get('Score'),
    userState: state.get('User')
  }),
  dispatch => ({
    scoreAction: bindActionCreators(actionScore, dispatch),
    userAction: bindActionCreators(actionUser, dispatch)
  })
)

export default class Score extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      limit: 10,
      scoreList: {},
      loading: false
    };
  }
  componentWillMount() {
    const { scoreAction, userAction } = this.props;
    userAction.fetchGetUserName();
    scoreAction.fetchGetScore({ page: this.state.page, limit: this.state.limit })
      .then(() => { this.handleData(); });
  }
  // props 改变时调用
  componentWillReceiveProps(nextProps) {
    const { userState, scoreState } = nextProps;
    const { data } = (userState && userState.toJS().data) || {};
    const exportData = (scoreState && scoreState.toJS().export.data) || {};
    this.setState({ userName: data, exportData: exportData });
  }
  // 设置状态
  setUser = (value) => {
    this.setState({
      user: (value && value.id) || '',
    })
  }

  handleData = () => {
    const { scoreState } = this.props;
    const { data } = scoreState.toJS().data;
    this.setState({ scoreList: data });
  };
  search = () => {
    const { page, limit, user } = this.state;
    const { scoreAction } = this.props;
    scoreAction.fetchGetScore({ page: page, limit: limit, userId: user })
      .then(() => { this.handleData(); })
  }
  // 弹窗控制
  handleOk = () => {
    this.setState({
      loaded: !this.state.loaded
    });
  }
  handleCancel = () => {
    this.setState({
      loaded: !this.state.loaded
    });
  }
  export = () => {
    const { scoreAction, scoreState } = this.props;
    this.setState({ loading: true });
    const { user } = this.state;
    scoreAction.fetchGetScoreExport({ id: user })
      .then(() => {
        const loaded = scoreState && scoreState.get('loaded');
        this.setState({ loaded: loaded, loading: false });
      })
  }
  pageChange = (page) => {
    this.setState({ page: page })
    const { limit, user } = this.state;
    const { scoreAction } = this.props;
    scoreAction.fetchGetScore({ page: page, limit: limit, userId: user })
      .then(() => { this.handleData(); })
  }
  render() {
    const { scoreList, userName, user, exportData } = this.state;
    const columns = [
      { title: '用户', dataIndex: 'username', render: (text, record) => <div>{record.user.username}</div> },
      { title: '电话', dataIndex: 'phone', render: (text, record) => <div>{record.user.phone}</div> },
      { title: '经销商', dataIndex: 'name', render: (text, record) => <div>{record.user.name}</div> },
      { title: '扫码量', dataIndex: 'scanNumber' },
      { title: '总积分', dataIndex: 'scoreTotal' },
      { title: '剩余积分', dataIndex: 'userableScore' }]
    return (
      <Card>
        <CardBlock>
          <Row className="form-group">
            <Col md="12">
              <div className="input-group">
                <Col md="4">
                  <Select
                    placeholder="用户名"
                    labelKey="name"
                    valueKey="id"
                    value={user || ''}
                    options={userName}
                    onChange={e => this.setUser(e)}
                  />
                </Col>
                <Col md="1">
                  <span className="input-group-btn">
                    <button size="large" onClick={this.search} className="btn btn-primary btn-pointer"><i className="fa fa-search" /> </button>
                  </span>
                </Col>
                <Col md="1">
                  <span className="input-group-btn">
                    <button size="large" onClick={this.export} className="btn btn-primary btn-pointer">导出</button>
                  </span>
                  <Modal
                    visible={this.state.loaded}
                    title="提示"
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                  >
                    <p>导出成功,请长按地址在浏览器打开</p>
                    <p>{SERVER_URL}/{exportData && exportData.data && exportData.data.downloadUrl}</p>
                  </Modal>
                </Col>
              </div>
            </Col>
          </Row>
          <Row className="form-group">
            <Col md="12">
              <Table
                loading={this.state.loading}
                pagination={false}
                rowKey="id"
                bordered
                columns={columns}
                dataSource={scoreList.docs}
                showHeader="false"
                size="middle"
              />
              <div className="card-block" style={{ 'margin-left': 'auto', 'margin-right': 'auto' }}>
                <Pagination
                  showLessItems
                  current={this.state.page}
                  pageSize={this.state.limit}
                  onChange={this.pageChange}
                  showTotal={(total, range) => `${range[0]} - ${range[1]} 共 ${total} 条`}
                  total={scoreList.total}
                />
              </div>
            </Col>
          </Row>
        </CardBlock>
      </Card>
    )
  }
}



// WEBPACK FOOTER //
// ./containers/App/Score/Score/index.js